<template>
  <div id="root">
    <h4 style="margin-top:0">Who do you want to record a vocation for?</h4>
    <el-autocomplete
      v-if="selectStudent"
      v-model="query"
      placeholder="Search people"
      :fetch-suggestions="queryStudents"
      value-key="name"
      @select="handleSelectStudent"
      id="searchAutocomplete"
      v-show="!selectedStudent"
      style="width: 100%;"
    />
    <h4
      class="title"
      style="margin-top:0;"
      v-if="selectedStudent"
    >
      {{ selectedStudent.name }}
    </h4>
    <div v-if="selectedStudent" class="container" style="margin-top:2rem;">
      <div class="row">
        <div class="col-md-6">
          Entering religious life or seminary?
        </div>
        <div class="col-md-6">
          <el-radio v-model="religiousOrSeminary" label="Religious" />
          <el-radio v-model="religiousOrSeminary" label="Seminary" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          Diocese or order:
        </div>
        <div class="col-md-6">
          <el-input
            placeholder="Diocese or order"
            v-model="dioceseOrOrder"
          />
        </div>
      </div>
    </div>
    <div>
      <p-button style="float: right" @click="clearInputs()">
        Cancel
      </p-button>
      <p-button
        style="float: right"
        class="custom-modal-type"
        @click="handleSave()"
        v-if="selectedStudent && religiousOrSeminary"
      >
        Save
      </p-button>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const GraduationRecordsRepository = RepositoryFactory.get('graduationRecords');

export default {
    name: 'VocationsForm',
    data() {
        return {
            namespace: 'GraduationRecords',
            religiousOrSeminary: false,
            dioceseOrOrder: null,
            selectedStudent: null,
            query: '',
        };
    },
    props: {
        selectStudent: {
            type: Boolean,
            default: false
        },
        students: {
            type: Array,
            default() { return []; }
        }
    },
    methods: {
        clearInputs() {
            this.religiousOrSeminary = false;
            this.dioceseOrOrder = null;
            this.query = '';
            this.selectedStudent = null;
        },
        handleClose() {
            this.clearInputs();
            this.$emit('close');
        },
        handleSave() {
            let seminary = false;
            let religious = false;
            if (this.religiousOrSeminary === 'Religious') {
                religious = true;
            } else if (this.religiousOrSeminary === 'Seminary') {
                seminary = true;
            }
            const vocation = {
                is_entering_religious: religious,
                is_entering_seminary: seminary,
                diocese_or_order: this.dioceseOrOrder,
                student: this.selectedStudent
            };
            this.$emit('saveVocation', vocation);
        },
        queryStudents(queryString, callback) {
            if (queryString.length === 0) callback(this.students);
            else {
                const results = queryString
                    ? this.students.filter(this.createFilter(queryString)) : this.students;
                callback(results);
            }
        },
        createFilter(queryString) {
            return (student) => student.name.toLowerCase().includes(queryString.toLowerCase());
        },
        handleSelectStudent(student) {
            this.selectedStudent = student;
        },
    },
};
</script>
